import * as React from 'react';
interface ContextType1 {
  iStage: number,
  tabCurrent: number,
  tabToastOpen: (text: string) => void,
}
const defaults1: ContextType1 = {
  iStage: 0,
  tabCurrent: 0,
  tabToastOpen: () => ''
}
const StageDefault = React.createContext(defaults1);

interface ContextType2 {
  current: number,
}
const defaults2: ContextType2 = {
  current: 0,
}
const StageCurrent = React.createContext(defaults2);

export {
  StageDefault,
  StageCurrent,
}